import { Link } from "react-router-dom";
import Block from "../components/Block";
import Seam from "../components/Seam";
import Seo from "../components/Seo";

export default function WhatWeDo() {
  return (
    <>
      <Seo
        title="What we do"
        description="Understand, shape, build, run: how Gapsmiths takes a problem from the first question to a working system."
      />
      <section className="wrap page-head">
        <h1>What we do</h1>
        <p className="lede">We work out what's wrong, and then we build what fixes it.</p>
      </section>

      <Seam />

      <Block marker="Where it starts">
        <h2>Most of our work starts before there's a brief</h2>
        <p>
          Someone knows something's off. Maybe a process runs on memory and WhatsApp,
          or a product idea has sat in a document for a year, or half the team quietly
          works around a system. They don't need a vendor yet. They need someone to
          work out what the real problem is, and then build what solves it.
        </p>
        <p>
          That's the whole of what we do. We figure out who it's for and what's
          actually broken. We shape it into something buildable, including being
          honest about where AI earns its place and where it doesn't. Then we build
          it, and we stay with it after launch, while people get used to working a new way.
        </p>
      </Block>

      <Seam />

      <Block marker="The four stages">
        <ol className="stages">
          <li>
            <div>
              <h3>Understand</h3>
              <p>
                Who's this for, what's actually broken, and is it worth fixing? We
                talk to the people who own the problem and the people who live with
                it. We work out how big the opportunity really is, and we write down
                the constraints (money, time, regulation, the team you have) before
                they surprise anyone.
              </p>
            </div>
          </li>
          <li>
            <div>
              <h3>Shape</h3>
              <p>
                We turn the problem into something buildable. We look at what others
                have tried, decide what to build first, and pick the tools, including
                whether AI belongs in it at all. Where the answer isn't obvious, we
                build a small proof before anyone commits real money.
              </p>
            </div>
          </li>
          <li>
            <div>
              <h3>Build</h3>
              <p>
                We build it, or we run the people who do: our team, yours, or vendors
                we've vetted. Either way you get one point of contact who knows the
                whole picture. Risks and blockers reach you early, not at the demo.
              </p>
            </div>
          </li>
          <li>
            <div>
              <h3>Run</h3>
              <p>
                Launch is the midpoint. We keep it running and change it as your
                business changes. We also help your people actually adopt it, because
                a system nobody uses is just an expensive way to keep doing things the
                old way.
              </p>
            </div>
          </li>
        </ol>
        <p className="small" style={{ marginTop: "2rem" }}>
          You can bring us in at any stage. Some clients need all four; some only need
          us to work out what to build.
        </p>
      </Block>

      <Seam />

      <Block marker="Ways of working">
        <h2>Engage with us</h2>
        <p>There are three ways to work with us.</p>
        <h3>A project</h3>
        <p>Defined scope, defined end. Good when you already know what you want built.</p>
        <h3>A retainer</h3>
        <p>Ongoing work across whatever comes up. Good when the problem keeps moving.</p>
        <h3>Embedded</h3>
        <p>We sit inside your team for a stretch. Good when the knowledge needs to stay with you afterwards.</p>
        <p>Once we've heard the problem, we can decide mutually what fits best.</p>
      </Block>

      <Seam />

      <Block marker="Next">
        <h2>Tell us what's not working</h2>
        <div className="actions">
          <Link className="btn btn-solid" to="/contact">Start a conversation</Link>
        </div>
        <p className="cta-contact">
          <a href="mailto:vivek@gapsmiths.com">vivek@gapsmiths.com</a><br />
          <a href="tel:+919323029857">+91 93230 29857</a>
        </p>
      </Block>
    </>
  );
}
